module.exports = __webpack_public_path__ + "img/meter.2a11ae97.svg";